"use client";

import { useState, useRef, useEffect } from "react";
import { useLocale } from "@/lib/locale-context";

// Кастомный выпадающий список городов (вместо нативного <select>) — оформлен под
// инпуты родительской формы (через inputStyle), со своим dropdown и закрытием по
// клику вне. Используется на /corporate и /payment.
export default function CityPicker({
  cities, station, onPick, isEn = false, inputStyle, placeholder,
}: {
  cities: { station: string; name: string }[];
  station: string;
  onPick: (station: string, name: string) => void;
  isEn?: boolean;
  inputStyle: React.CSSProperties;
  placeholder?: string;
}) {
  const { t, locale } = useLocale();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function onDoc(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);
  const selected = cities.find((c) => c.station === station);
  const ph = placeholder || (isEn || locale === "en" ? "Select a city" : t("form.selectCity"));
  return (
    <div ref={ref} style={{ position: "relative", width: "100%" }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          ...inputStyle,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          textAlign: "left",
          color: selected ? "#000" : "#9aa0a6",
        }}
      >
        <span>{selected ? ((isEn || locale === "en") && (selected as { name_en?: string }).name_en ? (selected as { name_en?: string }).name_en : selected.name) : ph}</span>
        <svg width="14" height="14" viewBox="0 0 12 12" fill="none" style={{ flexShrink: 0, transition: "transform 0.2s", transform: open ? "rotate(180deg)" : "rotate(0deg)" }}>
          <path d="M3 4.5L6 7.5L9 4.5" stroke="#8E8E93" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {open && cities.length > 0 && (
        <div style={{
          position: "absolute", top: "calc(100% + 6px)", left: 0, right: 0, zIndex: 40,
          background: "#fff", borderRadius: 12, boxShadow: "0 8px 28px rgba(20,29,69,0.16)",
          maxHeight: 280, overflowY: "auto", padding: 6,
        }}>
          {cities.map((c) => {
            const active = c.station === station;
            return (
              <button
                key={c.station}
                type="button"
                onClick={() => { onPick(c.station, c.name); setOpen(false); }}
                style={{
                  display: "block", width: "100%", textAlign: "left", padding: "11px 14px",
                  border: "none", borderRadius: 8, cursor: "pointer", fontSize: 16,
                  color: "#000", background: active ? "#EAF0FB" : "transparent",
                  fontWeight: active ? 600 : 400, fontFamily: "inherit",
                }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.background = "#EAF0FB"; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.background = active ? "#EAF0FB" : "transparent"; }}
              >
                {(isEn || locale === "en") && (c as { name_en?: string }).name_en ? (c as { name_en?: string }).name_en : c.name}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
